import React, { useState } from "react";
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Typography,
  Alert,
  Button,
} from "@mui/material";
import {
  Category as CategoryIcon,
  Schedule as ScheduleIcon,
  BookOnline as BookOnlineIcon,
  Settings as SettingsIcon,
  ConfirmationNumber as ConfirmationNumberIcon,
} from "@mui/icons-material";
import LessonTypeManager from "./LessonTypeManager";
import ScheduleManager from "./ScheduleManager";
import BookingsList from "./BookingsList";
import CarnetManager from "./CarnetManager";
import { initializeTestData } from "../utils/initializeTestData";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`booking-tabpanel-${index}`}
      aria-labelledby={`booking-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function BookingManagement() {
  const [activeTab, setActiveTab] = useState(0);
  const [initializingData, setInitializingData] = useState(false);
  const [initSuccess, setInitSuccess] = useState("");
  const [initError, setInitError] = useState("");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleInitializeTestData = async () => {
    try {
      setInitializingData(true);
      setInitError("");
      setInitSuccess("");

      await initializeTestData();
      setInitSuccess("Dati di test inizializzati con successo!");

      // Refresh the page components
      window.location.reload();
    } catch (error) {
      console.error("Error initializing test data:", error);
      setInitError("Errore nell'inizializzazione dei dati di test: " + error.message);
    } finally {
      setInitializingData(false);
    }
  };

  const tabs = [
    {
      label: "Prenotazioni",
      icon: <BookOnlineIcon />,
      component: <BookingsList />,
    },
    {
      label: "Tipi di Lezione",
      icon: <CategoryIcon />,
      component: <LessonTypeManager />,
    },
    {
      label: "Palinsesto",
      icon: <ScheduleIcon />,
      component: <ScheduleManager />,
    },
    {
      label: "Pacchetti",
      icon: <ConfirmationNumberIcon />,
      component: <CarnetManager />,
    }
  ];

  return (
    <Box>
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontSize: { xs: "1.25rem", sm: "1.5rem" },
          display: { xs: "none", sm: "block" }
        }}
      >
        Gestione Sistema Prenotazioni
      </Typography>

      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="booking management tabs"
          sx={{
            '& .MuiTab-root': {
              minWidth: { xs: 'auto', sm: 160 },
              fontSize: { xs: '0.75rem', sm: '0.875rem' },
              px: { xs: 1, sm: 2 }
            }
          }}
        >
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              icon={tab.icon}
              label={tab.label}
              iconPosition="start"
              sx={{
                flexDirection: { xs: 'column', sm: 'row' }
              }}
            />
          ))}
        </Tabs>
      </Paper>

      {tabs.map((tab, index) => (
        <TabPanel key={index} value={activeTab} index={index}>
          <Box sx={{ py: { xs: 1, sm: 2 } }}>
            {tab.component}
          </Box>
        </TabPanel>
      ))}
    </Box>
  );
}

export default BookingManagement;